export const WorldProperties = {
    width: 800,
    height: 600,
    velocity: 200,
    tileWidth: 16,
    tileHeight: 16,
    cameraZoom: 1.5
}

export const PersonaEvents = {
    "demo": [1, 13, 14, 2],     
    "student": [1, 2, 13, 3, 4, 14, 5],
    "fresh_grad": [3, 4, 13, 5, 6, 14, 7],
    "bachelor": [4, 16, 13, 9, 8, 14, 7],
    "married_man_original": [6, 7, 13, 8, 9, 14, 11],
    "married_man": [9, 16, 13, 8, 15, 14, 7],
    "family_man": [8, 9, 13, 10, 11, 14, 12]
}

export const SceneEventMapping = {
    "scene-1": [1, 4, 7, 10, 13],
    "scene-2": [2, 5, 8, 11, 14, 16],
    "scene-3": [3, 6, 9, 12, 15]
}